<ion-header class="transparent absolute">
    <app-header [middleIcon]="false" [hide930]="true"></app-header>
</ion-header>
<div class="blue-bg" [ngClass]="'bg-inner-'+userService.theme">
    <div class="content-wrap-inner">
        <img class="side-logo" [src]="userService.companyLogo">
        <div class="title my-color-blue">{{"__SC_DEV_TITLE__" | translate}}</div>

        <div class="text text-name" *ngIf="level == 'manager'"><strong
                class="my-color-blue">{{'__SC_DEV_NAME__' | translate}}</strong>
            <ng-container *ngIf="devReportData !== null">{{devReportData.delegate.full_name}}</ng-container>
        </div>

        <div class="text">{{"__SC_DEV_DESC__" | translate}}</div>

        <div class="select-group">
            <ng-select class="My-dropdown" [(ngModel)]="filter.type" [searchable]="false" [clearable]="false">
                <ng-option *ngFor="let item of dictionary.type1"
                           [value]="item.value">{{item.title | translate}}</ng-option>
            </ng-select>
        </div>

        <div class="select-group">
            <!--        <ion-select class="My-select small" [interface]="'popover'"-->
            <!--                    [(ngModel)]="filter.value">-->
            <!--            <ion-select-option *ngFor="let item of dictionary.type3"-->
            <!--                               [value]="item">{{item}}</ion-select-option>-->
            <!--        </ion-select>-->

            <ng-select class="My-dropdown small" [(ngModel)]="filter.value" [searchable]="false" [clearable]="false">
                <ng-option *ngFor="let item of dictionary.type3"
                           [value]="item">{{item}}</ng-option>
            </ng-select>

            <!--        <ion-select class="My-select" [interface]="'popover'"-->
            <!--                    [(ngModel)]="filter.direction">-->
            <!--            <ion-select-option *ngFor="let item of dictionary.type2"-->
            <!--                               [value]="item.value">{{item.title | translate}}</ion-select-option>-->
            <!--        </ion-select>-->

            <ng-select class="My-dropdown" [(ngModel)]="filter.direction" [searchable]="false" [clearable]="false">
                <ng-option *ngFor="let item of dictionary.type2"
                           [value]="item.value">{{item.title | translate}}</ng-option>
            </ng-select>

            <div *ngIf="!filter.status" class="btn touch-eff primary-bg-color"
                 (click)="onFilter(true)">{{"__SC_DEV_GO__" | translate}}
            </div>
            <div *ngIf="filter.status" class="btn touch-eff on primary-bg-color"
                 (click)="onFilter(false)">{{"__SC_DEV_RESET__" | translate}}
            </div>
        </div>

        <div class="box">
            <div class="line">
                <div class="el">
                    <div class="circle my-background-red"></div>
                    {{"__SC_DEV_ENTRY__" | translate}}
                </div>
                <div class="el">
                    <div class="circle my-background-black-dark"></div>
                    {{"__SC_DEV_DEVELOPING__" | translate}}
                </div>
                <div class="el">
                    <div class="circle my-background-yellow"></div>
                    {{"__SC_DEV_DELIVERY__" | translate}}
                </div>
            </div>
            <div class="line">
                <div class="el">
                    <div class="circle my-background-blue"></div>
                    {{"__SC_DEV_ADV_DELIVERY__" | translate}}
                </div>
                <div class="el">
                    <div class="circle my-background-green"></div>
                    {{"__SC_DEV_COACH_MENTOR__" | translate}}
                </div>
                <div class="el">
                    <div class="circle my-background-grey"></div>
                    {{"__SC_DEV_NOT_COMPLETED__" | translate}}
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="devReportData !== null" class="development-wrap content-wrap">
    <div *ngFor="let comp of devReportData.competencies">
        <div class="table">
            <div class="text"
                 [ngClass]="{'text-manager': level == 'manager', 'learner-only': devReportData.type === 'l'}">
                <div class="grid-col grid-col-1">{{"__SC_DEV_COMPET_ASSUM__" | translate}}</div>
                <div class="grid-col grid-col-2">{{"__SC_DEV_LEARNER__" | translate}}</div>
                <div class="grid-col grid-col-3"
                     *ngIf="devReportData.type === 'lm'">{{"__SC_DEV_MANAGER__" | translate}}</div>
                <div class="grid-col grid-col-4"
                     *ngIf="level == 'manager' && devReportData.type === 'lm'">{{"__SC_DEV_DESIRED__" | translate}}</div>
                <div class="grid-col grid-col-5"
                     *ngIf="devReportData.type === 'lm'">{{"__SC_DEV_GAP__" | translate}}</div>
                <div class="grid-col grid-col-6"
                     *ngIf="devReportData.type === 'lm'">{{"__SC_DEV_AGREED__" | translate}}</div>
            </div>
            <div class="line"
                 [ngClass]="{'line-manager': level == 'manager', 'learner-only': devReportData.type === 'l'}">
                <div class="grid-col grid-col-1 line-competency-title"
                     [ngClass]="comp.average.self.average.output.style.class">{{comp.title}}</div>
                <div class="grid-col grid-col-2"
                     [ngClass]="comp.average.self.average.output.style.class">{{comp.average.self.average.output.value}}</div>
                <div class="grid-col grid-col-3" *ngIf="devReportData.type === 'lm'"
                     [ngClass]="comp.average.manager.average.output.style.class">{{comp.average.manager.average.output.value}}</div>
                <div class="grid-col grid-col-4" *ngIf="level == 'manager' && devReportData.type === 'lm'"
                     [ngClass]="comp.average.desired.average.output.style.class">{{comp.average.desired.average.output.value}}</div>
                <div class="grid-col grid-col-5" *ngIf="devReportData.type === 'lm'"
                     [ngClass]="comp.average.gap.average.output.style.class">{{comp.average.gap.average.output.value}}</div>
                <div class="grid-col grid-col-6" *ngIf="devReportData.type === 'lm'"
                     [ngClass]="comp.average.agreed.average.output.style.class">{{comp.average.agreed.average.output.value}}</div>
            </div>
        </div>

        <div class="table">
            <div class="text"
                 [ngClass]="{'text-manager': level == 'manager', 'learner-only': devReportData.type === 'l'}">
                <div class="grid-col grid-col-1">{{"__SC_DEV_QUESTIONS__" | translate}}</div>
                <div class="grid-col grid-col-2">{{"__SC_DEV_LEARNER__" | translate}}</div>
                <div class="grid-col grid-col-3"
                     *ngIf="devReportData.type === 'lm'">{{"__SC_DEV_MANAGER__" | translate}}</div>
                <div class="grid-col grid-col-4"
                     *ngIf="level == 'manager' && devReportData.type === 'lm'">{{"__SC_DEV_DESIRED__" | translate}}</div>
                <div class="grid-col grid-col-5"
                     *ngIf="devReportData.type === 'lm'">{{"__SC_DEV_GAP__" | translate}}</div>
                <div class="grid-col grid-col-6"
                     *ngIf="devReportData.type === 'lm'">{{"__SC_DEV_AGREED__" | translate}}</div>
            </div>
            <div *ngFor="let question of comp.questions | skillsCheckerDevelopmentPipe: filter.type: filter.direction: filter.value: filter.status"
                 class="line"
                 [ngClass]="{'line-manager': level == 'manager', 'learner-only': devReportData.type === 'l'}">
                <div class="grid-col grid-col-1 my-background-white-dark">
                    {{question.question}}
                </div>
                <div class="grid-col grid-col-2"
                     [ngClass]="question.self.output.style.class">{{question.self.output.value}}</div>
                <div class="grid-col grid-col-3" *ngIf="devReportData.type === 'lm'"
                     [ngClass]="question.manager.output.style.class">{{question.manager.output.value}}</div>
                <div class="grid-col grid-col-4" *ngIf="level == 'manager' && devReportData.type === 'lm'"
                     [ngClass]="question.desired.output.style.class">{{question.desired.output.value}}</div>
                <div class="grid-col grid-col-5" *ngIf="devReportData.type === 'lm'"
                     [ngClass]="question.gap.output.style.class">{{question.gap.output.value}}</div>
                <div class="grid-col grid-col-6" *ngIf="devReportData.type === 'lm'"
                     [ngClass]="question.agreed.output.style.class">{{question.agreed.output.value}}</div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="devReportData === null" class="development-wrap content-wrap">
    <div class="table">
        <div class="text" [ngClass]="{'text-manager': level == 'manager'}">
            <div class="grid-col grid-col-1">
                <ion-skeleton-text animated></ion-skeleton-text>
            </div>
            <div class="grid-col grid-col-2">
                <ion-skeleton-text animated></ion-skeleton-text>
            </div>
            <div class="grid-col grid-col-3">
                <ion-skeleton-text animated></ion-skeleton-text>
            </div>
            <div class="grid-col grid-col-4" *ngIf="level == 'manager'">
                <ion-skeleton-text animated></ion-skeleton-text>
            </div>
            <div class="grid-col grid-col-5">
                <ion-skeleton-text animated></ion-skeleton-text>
            </div>
            <div class="grid-col grid-col-6">
                <ion-skeleton-text animated></ion-skeleton-text>
            </div>
        </div>
        <div *ngFor="let comp of [1,2,3,4,5]">
            <div class="line" [ngClass]="{'line-manager': level == 'manager'}">
                <div class="grid-col grid-col-1 my-background-white-dark"
                     style="flex-direction: column;align-items: flex-start;">
                    <ion-skeleton-text animated></ion-skeleton-text>
                    <ion-skeleton-text animated style="width: 90%"></ion-skeleton-text>
                    <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
                </div>
                <div class="grid-col grid-col-2">
                    <ion-skeleton-text animated></ion-skeleton-text>
                </div>
                <div class="grid-col grid-col-3">
                    <ion-skeleton-text animated></ion-skeleton-text>
                </div>
                <div class="grid-col grid-col-4" *ngIf="level == 'manager'">
                    <ion-skeleton-text animated></ion-skeleton-text>
                </div>
                <div class="grid-col grid-col-5">
                    <ion-skeleton-text animated></ion-skeleton-text>
                </div>
                <div class="grid-col grid-col-6">
                    <ion-skeleton-text animated></ion-skeleton-text>
                </div>
            </div>
        </div>
    </div>
</div>
